export const LOCAL_STORAGE_TOKEN_KEY = '_Slenv__tkSession'
export const LOCAL_STORAGE_LOGIN_USER_KEY = '_Slenv__loginUserKey'